module.exports = __webpack_public_path__ + "static/media/Vector_no.30c05193.svg";